import * as z from "zod/v4";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const TriggerEventDistributionItemSchema = z.object({
  eventType: z.string(),
  count: z.number(),
});

export const getMarketingAgentTriggerEventDistribution = {
  name: "getMarketingAgentTriggerEventDistribution" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.array(TriggerEventDistributionItemSchema),
};
